export default __webpack_public_path__ + "static/media/make7.e163a807.png";